import React from 'react';
import './LoadingSpinner.css';

/**
 * Accessible loading spinner. Use `size` to adjust visual size
 * ("small" | "medium" (default) | "large") and `label` for the
 * visible text next to/under the spinner.
 *
 * If `block` is true the spinner is wrapped in a centered block
 * suitable for placing inline in a page section.
 */
function LoadingSpinner({
  size = 'medium',
  label = 'Loading...',
  block = false,
  className = '',
}) {
  const spinner = (
    <div
      className={`loading-spinner ${size} ${className}`.trim()}
      role="status"
      aria-live="polite"
      data-testid="loading-spinner"
    >
      <div className="loading-spinner-ring" aria-hidden="true" />
      {label && <span className="loading-spinner-label">{label}</span>}
    </div>
  );

  if (block) {
    return <div className="loading-block">{spinner}</div>;
  }
  return spinner;
}

export default LoadingSpinner;
